import { findSameMessage } from 'actions/messenger/findSameMessage'
import { SocketData } from 'actions/socket/socketReceiveDataAction'
import { MessengerTextMessageComet } from 'api/comet/comet.types'
import { prepareMessagesStructure } from 'components/page/Chat/Messenger/Messenger.functions'
import {
  ChatMessage,
  ChatMessengerState,
} from 'reducers/messenger/ChatMessengerState'
import { isTimestampIncorrect } from 'reducers/messenger/function/isTimestampIncorrect'

export const addIncomingMessage = (
  incomingMessage: SocketData<MessengerTextMessageComet>,
  chatState: ChatMessengerState
): ChatMessengerState => {
  if (isTimestampIncorrect(chatState, Number(incomingMessage.content.time))) {
    return chatState
  }

  const sameMessage = findSameMessage(chatState.messages, incomingMessage)

  if (
    !Boolean(sameMessage) &&
    Number(incomingMessage.content.from_user_id) === chatState.selectedProfileId
  ) {
    const rawMessage = incomingMessage.content
    /**
     * В случае адекватной логики должно было бы мапится из основного значения.
     * Но по факту, все это дубль поля object 🙈
     */
    // const newMessage: ChatMessage = {
    //   id: rawMessage.msgid,
    //   uuid: String(rawMessage.msgid),
    //   user_from_id: Number(rawMessage.from_user_id),
    //   user_to_id: Number(rawMessage.to_user_id),
    //   folder_to_id: 0, // не откуда брать в случае канала mamba.messenger.message.{aid}
    //   contact_id: String(rawMessage.contactId),
    //   created: rawMessage.time,
    //   createdTs: Number(rawMessage.time),
    //   incoming: true,
    //   unread: true,
    //   type: MessengerItemTypes.TEXT,
    //   message: rawMessage.message,
    //   message_text: '',
    //   last_edit_date: null,
    // }
    const updateMessagesList: ChatMessage[] = [
      rawMessage.object,
      ...chatState.messages,
    ]

    return {
      ...chatState,
      chatData: {
        ...chatState.chatData,
        anketa: {
          ...chatState.chatData.anketa!,
        },
      },
      hasNewMessages: true,
      messages: updateMessagesList,
      messagesByDays: prepareMessagesStructure(updateMessagesList),
      updateReadedByContactId: rawMessage.contactId,
      updateContacts: true,
    }
  } else {
    console.warn('Ignore same message', sameMessage)
  }

  return chatState
}
